import type {
  LlmArticleSchema,
  LlmOrganization,
} from 'src/types/llm-article-schema';

export const normaliseLlmArticleSchema = (
  schema?: LlmArticleSchema | null,
): LlmArticleSchema | null => {
  if (!schema || typeof schema !== 'object') {
    return null;
  }

  if (
    Object.prototype.hasOwnProperty.call(schema, 'enabled') &&
    schema.enabled === false
  ) {
    return null;
  }

  const {
    image,
    publisher,
    enabled: _enabled,
    ['@context']: schemaContext,
    ['@type']: schemaType,
    ...rest
  } = schema as LlmArticleSchema;

  const normalisedSchema: LlmArticleSchema = {
    '@context': schemaContext ?? 'https://schema.org',
    '@type': schemaType ?? 'Article',
    ...rest,
  };

  if (image) {
    const rawImages = Array.isArray(image) ? image : [image];
    const formattedImages = rawImages.filter(
      (img): img is string => typeof img === 'string' && !!img,
    );

    if (formattedImages.length > 0) {
      normalisedSchema.image = formattedImages;
    }
  }

  if (publisher && typeof publisher === 'object') {
    const { logo, ...publisherRest } = publisher as LlmOrganization;
    let formattedLogo = logo;
    const logoObject = logo as { url?: string } | undefined;

    if (logoObject && typeof logoObject.url === 'string') {
      formattedLogo = {
        ...logoObject,
        url: logoObject.url,
      };
    }

    normalisedSchema.publisher = formattedLogo
      ? { ...publisherRest, logo: formattedLogo }
      : { ...publisherRest };
  }

  return normalisedSchema;
};
